import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { BAutoComplete } from "../../../../Components/common/B2BAutoComplete";
import { Bbutton } from "../../../../Components/common/B2BButton";
import { BCustomInput } from "../../../../Components/common/B2BCustomInput";
import { BRadio } from "../../../../Components/common/B2BRadio";
import { BFileUploader } from "../../../../Components/common/BDocUploader";
import { BSelect } from "../../../../Components/common/BSelect";
import { b2bConfig } from "../../../../Config";
import { Instance } from "../../../../Services/instance";
import { RootState } from "../../../../Store";
import "./index.css";

interface creditPageProps {
  className?: string;
}

interface acctActionFormProps {
  "bizid": any;
  "accountID": string;
  "currency": string;
  "amount": string;
  "action": string;
  "remark": string;
  "ref": string;
  refAttach: string;
}
export const CreditPage: React.FC<creditPageProps> = ({ className }) => {
  const { bzLst } = useSelector((state: RootState) => state.common);
  const [creditForm, setCreditForm] = useState<acctActionFormProps>({
    bizid: undefined,
    accountID: "",
    currency: "",
    amount: "",
    action: "credit",
    remark: "",
    ref: "",
    refAttach: ""
  });
  const ResetAction = () => {
    setCreditForm({
      bizid: undefined,
      accountID: "",
      currency: "",
      amount: "",
      action: "credit",
      remark: "",
      ref: "",
      refAttach: ""
    });
  };
  const { addToast } = useToasts();
  const onSubmitCreditForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      let formObj: any = {};
      formObj["bizid"] = creditForm.bizid.value.value;
      formObj["accountID"] = creditForm.accountID
        ? creditForm.accountID
        : creditForm.bizid.value.account[0].value;
      formObj["currency"] = creditForm.currency ? creditForm.currency : "MMK";
      formObj["action"] = "credit";
      formObj["amount"] = creditForm.amount;
      formObj["remark"] = creditForm.remark;
      formObj["ref"] = creditForm.ref;
      if (creditForm.refAttach && creditForm.refAttach.startsWith("data:")) {
        formObj["refAttach"] = creditForm.refAttach;
      }
      Instance({
        url: `${b2bConfig.apiPath.bzEntry}/admin-acct-action`,
        method: "POST",
        data: formObj
      })
        .then(res => {
          if (res.status === 200) {
            if (res.data && res.data.Status.Code === "01") {
              addToast(`Success`, { appearance: "success", autoDismiss: true });
            }
          } else if (res.data && res.data.Status.Code === "500") {
            addToast(`${JSON.stringify(res.data.Error)}`, {
              appearance: "warning",
              autoDismiss: true
            });
          }
        })
        .catch(err => {
          addToast(`System error - ${JSON.stringify(err)}`, {
            appearance: "error"
          });
        })
        .finally(() => {
          ResetAction();
        });
    } catch (error) {
      addToast(`System error - ${JSON.stringify(error)}`, {
        appearance: "error"
      });
    }
  };
  return (
    <div className={`${className} container`}>
      <div className="w-ful max-w-screen-md">
        <form
          onSubmit={e => {
            onSubmitCreditForm(e);
          }}
          className="px-4 py-4 rounded-md shadow-md flex flex-col space-y-2"
        >
          <BAutoComplete
            title="Search Business"
            items={bzLst}
            formData={creditForm}
            setFormData={setCreditForm}
            name="bizid"
            id="bizid"
          />
          <BSelect
            formData={creditForm}
            label="Choose Account"
            setFormData={setCreditForm}
            name="accountID"
            id="accountID"
            options={
              creditForm.bizid &&
              creditForm.bizid.value &&
              creditForm.bizid.value.account
                ? creditForm.bizid.value.account
                : []
            }
          />
          <BCustomInput
            required={true}
            type="text"
            setFormData={setCreditForm}
            label="Enter Amount"
            name="amount"
            id="amount"
            formData={creditForm}
          />
          <div className="flex w-full space-x-2">
            <label htmlFor="currency" className="text-secondary text-sm">
              Choose Curreny
            </label>
            <BRadio
              inline
              radios={[
                { text: "MMK", value: "MMK" },
                { text: "USD", value: "USD" }
              ]}
              setFormData={setCreditForm}
              formData={creditForm}
              name="currency"
              id="currency"
            />
          </div>
          <BCustomInput
            required={true}
            type="text"
            setFormData={setCreditForm}
            label="Remark"
            name="remark"
            id="remark"
            formData={creditForm}
          />
          <BCustomInput
            required={true}
            type="text"
            setFormData={setCreditForm}
            label="Ref:"
            name="ref"
            id="ref"
            formData={creditForm}
          />
          <BFileUploader
            setFormData={setCreditForm}
            label="RefAttach:"
            name="refAttach"
            id="refAttach"
            formData={creditForm}
          />
          <div className="flex flex-start">
            <Bbutton title="Submit" type="submit" />
          </div>
        </form>
      </div>
    </div>
  );
};
